import React from 'react';
import moment from 'moment/moment';

import {
  AccordionDetails,
  Button,
  IconButton,
  Typography,
} from '@mui/material';
import { Cancel } from '@mui/icons-material';

import SmsResult from '../../../../../routes/App/Sms/Components/SmsResultDialog/SmsResult';
import SmsResultErrors from '../../../../../routes/App/Sms/Components/SmsResultDialog/SmsResultErrors';
import { Consumer } from '../../../../Container/Language/TranslationsContext';

const isOld = (started) => !started || moment(new Date()).diff(moment(started)) > 1800000; // 30 min

const CancelBtn = ({ queue, dropQueue }) => (!queue.finished && isOld(queue.started) ? (
  <IconButton size="small" onClick={() => dropQueue(queue.id)} sx={{ position: 'absolute', right: 15 }}>
    <Cancel />
  </IconButton>
) : null);

const QueueItemDetails = ({ queue, dropQueue }) => (
  <AccordionDetails>
    <CancelBtn queue={queue} dropQueue={dropQueue} />
    <Consumer>
      {({ t }) => {
        const resultErrors = queue?.result?.errors;
        if (queue.finished && Array.isArray(resultErrors) && resultErrors.length) {
          return (<SmsResultErrors errors={resultErrors} />);
        }

        if (queue.finished && queue?.result?.error) {
          return (
            <Typography color="error">
              {t('app:controller:sms:popup:error:unknown')}
            </Typography>
          );
        }

        switch (queue.type) {
          case 'campaign': return (<SmsResult {...queue} />);
          case 'reportApiExport':
          case 'reportSingleExport':
          case 'smsByIncomeExport':
          case 'bulkExport': return (!queue.finished
            ? (queue.text || (Number(queue.percent) > 0 ? `${Math.round(queue.percent)}%` : ''))
            : (queue.result?.report ? (
              <Button href={queue.result.report} target="_blank" size="small">
                {t('app:common:download')}
              </Button>
            ) : null)
          );
          case 'schedulerRemove':
          case 'bulkRemove':
            return !queue.finished
              ? (queue.text || '')
                .replace('Поиск смс для удаления...', t('app:controller:report:popup:waiting:find'))
                .replace('Идет удаление смс...', t('app:controller:report:popup:waiting:removing'))
                .replace('Обновление баланса...', t('app:controller:report:popup:waiting:balance'))
              : t('app:controller:report:popup:waiting:success');
          case 'deliveredSave':
            return !queue.finished
              ? (queue.text || '')
                .replace('Подготовка рабочих номеров к сохранению...', t('app:controller:report:popup:waiting:prepare'))
                .replace('Сохранение списка...', t('app:controller:report:popup:waiting:saving'))
              : t('app:controller:report:param:delivered:saved');
          default:
            return queue.text;
        }
      }}
    </Consumer>
  </AccordionDetails>
);

export default QueueItemDetails;
